<template>
  <div>
    <!-- Button Add New Opt In Auction  -->
    <div style="float: right">
      <md-button
        class="md-icon-button md-primary md-simple new-app-button"
        style="padding: 10px; padding-right: 17px;"
        @click="openOptInAuctionItemForm({})"
      >
        <md-icon id="new-app-icon">
          note_add
        </md-icon>
          New subscription
        <md-tooltip md-direction="top">
          Add new subscription
        </md-tooltip>
      </md-button>
      <loading-icon-button
        tooltip="Refresh"
        style="padding: 10px"
        @click="getOptInAuctionList"
      >
        refresh
      </loading-icon-button>
    </div>
    <!-- Opt in Auctions Edit Form -->
    <md-dialog :md-active.sync="showOptInAuctionEditForm">
      <ValidationObserver v-slot="{ invalid }">
        <div class="dialogWrapper">
          <group-card>
            <!-- Conditional Fields for the Title -->
            <md-dialog-title v-if="newOptInAuctionObject">
              Create subscription for new auction
            </md-dialog-title>
            <md-dialog-title v-else>
              Edit auction type for {{ opt_in_auction.broker_name }}
            </md-dialog-title>
            <br />
            <div
              class="md-layout md-gutter"
              style="width: auto;"
            >
              <validated-autocomplete-input
                class="md-layout-item"
                label="Tier Name"
                v-model="opt_in_auction.tier_name"
                :options="options.all_tier_names"
                required
              />
            </div>
            <!-- Conditional Fields for Broker name -->
            <div
              class="md-layout md-gutter"
              style="width: auto;"
            >
              <!-- Field for Exisiting Broker -->
              <validated-autocomplete-input
                class="md-layout-item"
                label="Broker"
                id="existing-broker-opt-in"
                v-if="!newOptInAuctionObject"
                v-model="opt_in_auction.broker_name"
                disabled
              />
              <!-- Field for New Broker -->
              <div
                class="md-layout-item"
                v-if="newOptInAuctionObject"
              >
                <md-field>
                  <label for="new-broker-opt-in">
                    Broker
                  </label>
                  <md-input
                    id="new-broker-opt-in"
                    v-model="brokerSearch.query"
                    @keyup="searchBroker"
                    errormsg="This field is required"
                    required
                  />
                </md-field>
                <v-data-table
                  v-if="brokerSearch.results
                    && brokerSearch.query
                    && brokerSearch.searching"
                  :items="brokerSearch.results"
                  :headers="headers"
                  hide-default-header
                  loading
                  loading-text="Searching for broker name..."
                  item-key="id"
                  @click:row="handleClick"
                  hide-default-footer
                  class="elevation-1"
                ></v-data-table>
              </div>
            </div>
            <div v-if="invalid">
              <p class="error-message">
                Please enter valid data to save changes
              </p>
            </div>
            <md-dialog-actions>
              <md-button
                class="md-primary md-simple"
                @click="cancelOptInAuctionItemForm"
              >
                Cancel
              </md-button>
              <md-button
                class="md-primary"
                @click="saveOptInAuctionItemForm()"
                :disabled="isOptInAuctionFormDisable(invalid)"
              >
                {{ newOptInAuctionObject ? 'Save' : 'Update' }}
              </md-button>
            </md-dialog-actions>
          </group-card>
        </div>
      </ValidationObserver>
    </md-dialog>
    <data-table
      :headers="optInServiceHeaders"
      v-model="optInServicesData"
      :items-per-page="10"
      title="Auction Subscriptions"
      filterable
    >
      <template v-slot:item.opt_in_action="{ item }">
        <LoadingIconButton
          tooltip="Edit this subscription"
          @click="openOptInAuctionItemForm(item)"
        >
          edit
        </LoadingIconButton>
        <LoadingIconButton
          tooltip="Delete this subscription"
          @click="deleteOptInAuctionItem(item)"
        >
          clear
        </LoadingIconButton>
      </template>
    </data-table>
    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";
import { GroupCard } from "@/components";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";

export default {
  components: {
    DataTable,
    LoadingIconButton,
    ...ValidatedInputs,
    GroupCard,
    ConfirmDialog,
  },
  created() {
    this.getOptInAuctionList();
  },
  data() {
    return {
      newOptInAuctionObject: false,
      selectedBroker: {},
      headers: [
        { text: 'id', value: 'id' },
        { text: 'Name', value: 'name' },
      ],
      brokerSearch: {
        query: null,
        results: null,
        searching: false
      },
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      showOptInAuctionEditForm: false,
      opt_in_auction: {},
      originalOptInAuctionItem: {}, //initial state OptIn when page is loaded

      optInServiceHeaders: [
        {
          text: "Broker Name",
          value: "broker_name",
          sort: true,
          search: true
        },
        {
          text: "Tier Name",
          value: "tier_name",
          sort: true,
          search: true
        },

        {
          text: "Created On",
          value: "created_at",
          sort: false,
        },
        {
          text: "Updated On",
          value: "updated_at",
          sort: false,
        },
        {
          text: "Action",
          value: "opt_in_action",
          sort: false,
        },
      ],
      optInServicesData: [],
    };
  },
  methods: {
    async searchBroker() {
      if (this.brokerSearch.query.length > 2) {
        this.brokerSearch.searching = true;
        let { data: users } = await axios.get(`/api/v1/administration/role_based_users/${this.brokerSearch.query}/broker`);
        this.brokerSearch.results = users;
        this.brokerSearch.searching = true;
      }
    },
    handleClick(broker) {
      this.selectedBroker = broker;
      this.brokerSearch.query = broker.name;
      this.brokerSearch.results = null;
      this.brokerSearch.searching = false;
    },
    isOptInAuctionFormDisable(invalid) {
      // process differently depends on new or exist
      if (this.newOptInAuctionObject) {
        if (this.brokerSearch.query == null
          || this.brokerSearch.query === ""
          || this.selectedBroker['id'] === undefined
          || this.brokerSearch.searching
          || invalid)
          return true
      } else {
        // if object didn't changed
        if (JSON.stringify(this.opt_in_auction) === JSON.stringify(this.originalOptInAuctionItem) || invalid)
          return true;
      }

      return false;
    },
    async getOptInAuctionList() {
      await axios.get(`/api/v1/administration/auction_service_subscriptions`)
        .then(res => {
          this.optInServicesData.length = 0;
          for (const item of res.data) //map db object to necessary front list object
          {
            const element = {};
            element['id'] = item.id;
            element['user_id'] = item.user.id;
            element['broker_name'] = filters.name(item.user.name);
            element['tier_name'] = item.auction_service.name;
            const created_at = new Date(item.created_at);
            element['created_at'] = created_at.toLocaleString();
            const updated_at = new Date(item.updated_at);
            element['updated_at'] = updated_at.toLocaleString();

            this.optInServicesData.push(element);
          }
        })
        .catch(err => {
          console.error("Error getting optInServicesData", err);
          this.showUserDialog("Seems like a small problem with getting data..", err.response.data.error);
        });
    },
    showUserDialog(title, message) {
      this.error_dialog.show = true;
      this.error_dialog.title = title;
      this.error_dialog.content = message;
    },
    openOptInAuctionItemForm(selectedOptInAuctionItem) {
      if (Object.keys(selectedOptInAuctionItem).length === 0) {
        // anytime when open new Opt in broker form must set up these fields
        this.newOptInAuctionObject = true;
        this.brokerSearch.query = null;
      }
      else {
        this.newOptInAuctionObject = false;
      }

      this.opt_in_auction = selectedOptInAuctionItem;
      this.originalOptInAuctionItem = { ...selectedOptInAuctionItem };

      this.showOptInAuctionEditForm = true;
    },
    async deleteOptInAuctionItem(selectedOptInAuctionItem) {
      // confirmation dialog to delete
      let userAction = await this.$modal.show(ConfirmDialog, {
        title: "Warning! Action confirmation!",
        message: `Are you sure want to delete subscription ${selectedOptInAuctionItem.tier_name} for ${selectedOptInAuctionItem.broker_name} ?`,
        important: "Delete subscription",
        confirmText: "Delete",
        cancelText: 'Cancel',
      });
      if (userAction) {
        await axios.delete(`/api/v1/administration/auction_service_subscriptions/${selectedOptInAuctionItem.id}`)
        .then(res => {
          // if success need a fresh list
          this.getOptInAuctionList();
          this.showUserDialog(`Auction Subscription for ${selectedOptInAuctionItem.broker_name} has been deleted!`, "");
        })
        .catch(err => {
          console.error("Delete Auction Subscription Item request failed", err);
          this.showUserDialog("Seems like a small problem with Auction Subscription deleting ..", err.response.data.error);
        });
      }
    },
    async saveOptInAuctionItemForm() {
      if (this.newOptInAuctionObject === true) {  // we have a new object - Creation
        let optInAuctionItemCreate = {};
        optInAuctionItemCreate['user_id'] = this.selectedBroker.id;
        optInAuctionItemCreate['tier_name'] = this.opt_in_auction.tier_name;
        await axios.post(`/api/v1/administration/auction_service_subscriptions`, optInAuctionItemCreate)
          .then(res => {
            this.showUserDialog(`New ${this.opt_in_auction.tier_name} subscription for ${this.selectedBroker.name} has been created.`, "");
            // if success need a fresh list
            this.getOptInAuctionList();
          })
          .catch(err => {
            console.error("Create New Opt In Auction form request failed", err);
            this.showUserDialog("Seems like a small problem with New Opt In Auction creation...", err.response.data.error);
          });
      }
      else { //updation
        let optInAuctionItemUpdate = {};
        optInAuctionItemUpdate['user_id'] = this.opt_in_auction.user_id;
        optInAuctionItemUpdate['tier_name'] = this.opt_in_auction.tier_name;
        // we have an updated object
        await axios.patch(`/api/v1/administration/auction_service_subscriptions/${this.opt_in_auction.id}`, optInAuctionItemUpdate)
          .then(res => {
            this.showUserDialog(`${this.opt_in_auction.tier_name} subscription has been assigned for ${this.opt_in_auction.broker_name}.`, "");
            // if success need a fresh list
            this.getOptInAuctionList();
          })
          .catch(err => {
            console.error("Save Opt In Auction form updation request failed", err);
            this.showUserDialog("Seems like a small problem with Saving Auction form updation ..", err.response.data.error);
            // if failed must return original state of the form
            this.getOptInAuctionList();
          });
      }

      this.showOptInAuctionEditForm = false;
    },
    cancelOptInAuctionItemForm() {
      // if cancel clicked and form has been modified, must return original state of the form
      if (JSON.stringify(this.opt_in_auction) !== JSON.stringify(this.originalOptInAuctionItem)) {
        this.getOptInAuctionList();
      }
      this.showOptInAuctionEditForm = false;
    },
    ...filters
  },
  computed: {
    ...mapGetters([
      'options',
    ]),

  },
  filters: {
    ...filters
  },
  async beforeCreate() {
    const params = {
      types: [
        'all_tier_names',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.dialogWrapper {
  padding: 30px;
}

.error-message {
  color: red;
  padding: 6px;
  margin: 15px 30px;
  text-align: center;
}
</style>
